import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    setting: {
      namespaced: true,
      state: {
        // 订单提醒是否自动轮播
        sbtxSwiper: true,
        // 数据统计是否自动轮播
        ssyjSwiper: true,
        // 是否进行大屏自适应缩放
        isScale: true,
        // ECharts图表自动刷新间隔(ms)
        echartsAutoTime: 30000,
        // vue-seamless-scroll 默认滚动配置
        defaultOption: {
          step: 0.5,
          waitTime: 1000,
          singleHeight: 0,
          limitMoveNum: 5
        }
      },
      mutations: {
        initSwipers(state) {
          state.sbtxSwiper = true
          state.ssyjSwiper = true
        },
        updateSwiper(state, { val, type }) {
          state[type] = val
        }
      }
    }
  }
})
